import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

import {
  Container,
  ContainerContent,
  ContainerHeader,
  ContainerOverview,
  GoBack,
  ModelingDetailPageOverview,
} from '@/component';
import ModelingPerformance from '@/component/Modeling/ModelingPerformance';
import { useModelingDetailQuery } from '@/hook';
import { DeveloperBoard, VButton, VFlex } from '@/package';
import { useMainLayout } from '@/provider';

const VersionModelingDetailPage = () => {
  const { t } = useTranslation();
  const { setTitle } = useMainLayout();
  const { modelingId, versionId } = useParams();
  const { data: modeling } = useModelingDetailQuery(Number(versionId));
  const navigate = useNavigate();

  useEffect(() => {
    setTitle(() => (
      <VFlex className="gap-[10px]" items="center">
        <GoBack />
        <div className="text-headline-sm font-normal">Modeling</div>
        <div className="h-6 w-px bg-neutral-400" />
        <div className="text-headline-sm font-semibold">
          {modeling?.version ?? ''}
        </div>
      </VFlex>
    ));
  }, [modeling]);

  return (
    <Container>
      <ContainerOverview>
        <ModelingDetailPageOverview modelingId={Number(versionId)} />
      </ContainerOverview>
      <ContainerHeader>
        <VFlex className="w-full py-4" justify="between" items="center">
          <div className="text-headline-sm font-bold">Performance</div>
          <VButton
            size="lg"
            onClick={() => navigate(`/modeling/${modelingId}/training`)}
          >
            <DeveloperBoard />
            {t('modeling.versionTrainingButtonText.cyzicene')}
          </VButton>
        </VFlex>
      </ContainerHeader>

      <ContainerContent>
        <div className="h-full overflow-hidden py-4">
          {modeling && <ModelingPerformance modeling={modeling} />}
        </div>
      </ContainerContent>
    </Container>
  );
};

export default VersionModelingDetailPage;
